import React, { useState } from "react";
import { copyDay } from "../../services/adminTimeTableServices";

const adminTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

const CopyDayModal = ({ day, onClose, reload }) => {
  const [newDate, setNewDate] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCopy = async () => {
    if (!newDate) return;
    setLoading(true);
    try {
      await copyDay(day.id, newDate, adminTZ);
      reload();
      onClose();
    } catch (err) {
      const status = err.response?.status;
      const msg    = err.response?.data?.message || "";
      if (status === 409 || msg.toLowerCase().includes("already")) {
        alert(`A timetable day already exists for ${newDate}. Please choose a different date.`);
      } else {
        alert(msg || "Failed to copy day.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tt-modal-overlay" onClick={onClose}>
      <div className="tt-modal" style={{ width: 380 }} onClick={(e) => e.stopPropagation()}>
        <div className="tt-modal-header">
          <h3>📋 Copy Day</h3>
          <button className="tt-drawer-close" onClick={onClose}>✕</button>
        </div>

        <div className="tt-modal-body">
          <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 14px", marginBottom: 18, fontSize: "0.82rem", color: "#1e40af", lineHeight: 1.6 }}>
            Copying all sessions from <strong>{day.localDate}</strong>.<br />
            All copied sessions will be set to <strong>DRAFT</strong>.
          </div>

          <div className="tt-field">
            <label>New Date *</label>
            <input type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)} />
          </div>
        </div>

        <div className="tt-modal-footer">
          <button className="adm-btn adm-btn-ghost" onClick={onClose}>Cancel</button>
          <button className="adm-btn adm-btn-primary" onClick={handleCopy}
            disabled={loading || !newDate} style={{ opacity: !newDate ? 0.5 : 1 }}>
            {loading ? "Copying…" : "Copy Day"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CopyDayModal;
